import React from "react";
import { Grid, ThemeProvider, Typography, createTheme } from "@mui/material";
import bannerImg from "../../img/tghbanner.png";
import pumpFunImg from "../../img/grethulvingLogo.png";
import pumpPill from "../../img/pumpPill.png";
import dexLogo from "../../img/dexLogo.png";

const MainPage = () => {
  return (
    <div className="box--gradient silver" style={{ padding: 16 }}>
      <Grid container spacing={2}>
        {/* Top Row */}
        <Grid item xs={12}>
          <img
            src={bannerImg}
            alt="Top Row"
            style={{ width: "100%", height: 300, objectFit: "cover" }}
          />
        </Grid>
        {/* Bottom Row */}
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {/* First Column */}
            <Grid item xs={12} sm={3}>
              {/* Image with text */}
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "black",
                  padding: 2,
                  margin: 2,
                }}
              >
                {" "}
                <a
                  href="https://pump.fun"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={pumpPill}
                    alt="Pump Fun"
                    style={{ width: "100%", maxHeight: 400 }}
                  />
                </a>
                <Typography sx={{ color: "#AFEEEE", fontSize: "5px" }}>
                  Launched on pump.fun
                </Typography>
                <br></br>
              </div>
            </Grid>
            {/* Second Column */}
            <Grid item xs={12} sm={6}>
              {/* Image with text */}
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "black",
                  padding: 2,
                  margin: 2,
                }}
              >
                <Typography sx={{ color: "#AFEEEE" }} variant="body1">
                  What is $TGH?
                </Typography>
                <br></br>
                <Typography sx={{ color: "#AFEEEE", fontSize: "5px" }}>
                  First lets talk about halving in general. Bitcoin halving is
                  like a cosmic event in the cryptocurrency universe, occurring
                  approximately every four years. It's when the rewards for
                  mining new blocks are sliced in half, making it tougher to get
                  your hands on those shiny digital coins. It's like finding out
                  your favorite pizza joint is giving out half as many free
                  slices – you'll have to work twice as hard for that cheesy
                  goodness. So, for our meme coin, it's a reminder that even in
                  the digital world, scarcity adds a sprinkle of excitement to
                  the mix!
                </Typography>
                <Typography sx={{ color: "#AFEEEE" }} variant="body1">
                  CA coming soon!
                </Typography>
              </div>
            </Grid>
            {/* Third Column */}
            <Grid item xs={12} sm={3}>
              {/* Image with text */}
              <div
                style={{
                  textAlign: "center",
                  backgroundColor: "black",
                  padding: 2,
                  margin: 2,
                }}
              >
                {" "}
                <a
                  href="https://dexscreener.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={dexLogo}
                    alt="Pump Fun"
                    style={{ width: "100%", maxHeight: 400 }}
                  />
                </a>
                <Typography sx={{ color: "#AFEEEE", fontSize: "5px" }}>
                  DEX SOON!
                </Typography>
                <br></br>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default MainPage;
